import { RequestContext, WPS, NavLink,
    NavigationMainMenu, NavigationLocaleSelector, NavigationYourAccount,
    NavigationSearchForm,
    NavLanguage} from 'DVWebNodeUtils'

import { NavParamsProps } from '../index'
import { buildCurrentUrlWithLocaleReftag } from '../../utils/url';
import { ProfilesProps, transformProfiles } from '../../Shared/transforms/Profiles';

const annotatedLinkDelimiter = '$$'

const encodeHTML = (s: string) => {
  return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;')
}

const transformForSearchPhrase = ({phrase}: { phrase: string }) => {
  if (phrase) {
    return encodeHTML(phrase)
  }
}

const transformForSearchBar = (searchForm: NavigationSearchForm, isElcano: Boolean, searchHistoryTreatment: string) => {
  if (searchForm) {
    return {
      shouldCollapse: isElcano,
      searchFormAction: searchForm.action,
      searchFormPlaceholder: searchForm.placeholder,
      searchPhrase: transformForSearchPhrase(searchForm),
      searchSuggestionsEndpoint: searchForm.searchSuggestionsEndpoint,
      altText: searchForm.altText,
      searchHistory: {
        treatment: searchHistoryTreatment,
        strings: searchForm.searchHistory.strings
      }
    }
  }
}

const formatLinkText = (str: string, params: NavParamsProps) => (
  str.replace('#FIRST_NAME#', params.firstName || '')
)

const transformYourAccountLinks = (links: NavLink[], params: NavParamsProps, context: RequestContext) =>
  links.map((link: NavLink) => {
  // AnnotatedLink
    if (links.length === 1) {
      if (link.text.indexOf(annotatedLinkDelimiter) > -1) { // eslint-disable-line no-magic-numbers
        const text = link.text.substring(
          link.text.indexOf(annotatedLinkDelimiter) + annotatedLinkDelimiter.length,
          link.text.lastIndexOf(annotatedLinkDelimiter)
        )

        return Object.assign({}, link, {
          text: formatLinkText(text, params),
          href: Boolean(!context.customerID && link.href.indexOf('/auth-redirect') > -1) ? params.signInLink : link.href,
          pre: formatLinkText(link.text
            .substring(0, link.text.indexOf(annotatedLinkDelimiter)), params),
          post: formatLinkText(link.text
            .substring(link.text
              .lastIndexOf(annotatedLinkDelimiter) +
          annotatedLinkDelimiter.length, link.text.length), params)
        })
      }

      /*
      This is the case where we have an array of size 1 but
      it's not a annotated link (= does not contain $$)
    */
      return Object.assign({}, link, {
        text: formatLinkText(link.text, params),
        href: Boolean(!context.customerID && link.href.indexOf('/auth-redirect') > -1) ? params.signInLink : link.href
      })
    }

    const formattedLink = Object.assign({}, link, {
      text: formatLinkText(link.text, params),
      href: Boolean(!context.customerID && link.href.indexOf('/auth-redirect') > -1) ? params.signInLink : link.href
    })
    return formattedLink
  })

export const transformForYourAccountLocaleSubMenu = (localesSelector: NavigationLocaleSelector, context: RequestContext, params: NavParamsProps) => {
  if (localesSelector) {
    return {
      text: localesSelector.heading,
      locales: localesSelector.locales,
      languages: transformLanguages(context, localesSelector.languages),
      languageToken: params.languageToken,
      dropdownIndex: (context.customerID ? 0 : 1)
    }
  }
}

export const transformForYourAccount = (
  yourAccount: NavigationYourAccount,
  localesSelector: NavigationLocaleSelector,
  context: RequestContext,
  params: NavParamsProps
) => ({
  altText: yourAccount.altText,
  links: transformYourAccountLinks(yourAccount.links, params, context),
  localeSelectionSubMenu: transformForYourAccountLocaleSubMenu(localesSelector, context, params),
  strings: yourAccount.strings
})

const transformLanguages = (context: RequestContext, languages: NavLanguage[]) =>
  languages.map(language => ({
    ...language,
    url: buildCurrentUrlWithLocaleReftag(context, language.refMarker)
  }))

export const transformForLocaleSelector = (localesSelector: NavigationLocaleSelector,
                                          context: RequestContext, params: NavParamsProps) => {
  if (localesSelector) {
    return {
      text: localesSelector.currentLocaleText,
      locales: localesSelector.locales,
      languages: transformLanguages(context, localesSelector.languages),
      languageToken: params.languageToken
    }
  }
}

export const transformForMainMenu = (mainMenu: NavigationMainMenu, isElcano: boolean) => {
  if (mainMenu) {
    return {
      text: mainMenu.text,
      links: mainMenu.primaryLinks,
      isElcano: isElcano
    }
  }
}

export const transformNav = (data: WPS.Navigation.Response, context: RequestContext, params: NavParamsProps, cerberusProps: ProfilesProps) => {
  return {
    logo: {
      targetUrl: data.logo.href,
      altText: data.logo.altText,
      imageURL: data.logo.imageURL
},
    mainMenu: transformForMainMenu(data.mainMenu, params.isElcano),
    signUpCTA: data.signUpCTA,
    searchBar: transformForSearchBar(data.searchForm, params.isElcano, params.searchHistoryTreatment),
    yourAccount: transformForYourAccount(data.yourAccount, data.localeSelector, context, params),
    cerberus: transformProfiles(cerberusProps, context),
    localeSelector: transformForLocaleSelector(data.localeSelector, context, params),
    context
  }
}

export default transformNav
